/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_StatusInputs */

const en_admin_resources_resource_allocations_status = /** @type {(inputs: Admin_Resources_Resource_Allocations_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const de_admin_resources_resource_allocations_status = /** @type {(inputs: Admin_Resources_Resource_Allocations_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const es_admin_resources_resource_allocations_status = /** @type {(inputs: Admin_Resources_Resource_Allocations_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const fr_admin_resources_resource_allocations_status = /** @type {(inputs: Admin_Resources_Resource_Allocations_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_StatusInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_status = en_admin_resources_resource_allocations_status;

/** @type {(inputs: Admin_Resources_Resource_Allocations_StatusInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_status = en_admin_resources_resource_allocations_status;

/** @type {(inputs: Admin_Resources_Resource_Allocations_StatusInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_status = en_admin_resources_resource_allocations_status;

/** @type {(inputs: Admin_Resources_Resource_Allocations_StatusInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_status = en_admin_resources_resource_allocations_status;

/** @type {(inputs: Admin_Resources_Resource_Allocations_StatusInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_status = en_admin_resources_resource_allocations_status;

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Admin_Resources_Resource_Allocations_StatusInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_status = /** @type {((inputs?: Admin_Resources_Resource_Allocations_StatusInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_StatusInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_status(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_status(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_status(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_status(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_status(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_status(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_status(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_status(inputs)
	return ro_admin_resources_resource_allocations_status(inputs)
});
export { admin_resources_resource_allocations_status as "admin.resources.resource_allocations.status" }